import { gql, useQuery } from '@apollo/client';

export type DomainListData = {
  domainList: string[];
};

const GET_DOMAINS_LIST = gql`
  query GetDomainList {
    domainList
  }
`;

type UseDomainListReturnType = {
  data?: DomainListData;
  loading: boolean;
};

export const useDomainList = (): UseDomainListReturnType => {
  const { error, data, loading } = useQuery<DomainListData>(GET_DOMAINS_LIST);

  if (error || !data) {
    // throw error;
  }

  return {
    data,
    loading,
  };
};
